import React from 'react'

import { styled } from '@mui/material/styles'
import ButtonBase from '@mui/material/ButtonBase'

import { OptionId, optionsDict } from '../../data/options'
import { T } from '../../utils/Typography'

import { QuizStoreContext } from '../../contexts/quizContext'

import ImageWithLoading from '../ImageWithLoading/ImageWithLoading'
import { ButtonProps } from '@mui/material/Button'

interface ImageButtonProps extends ButtonProps {
  selected?: boolean
}

const ImageButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<ImageButtonProps>(({ theme, selected }) => ({
  position: 'relative',
  height: '100%',
  borderColor: selected ? '#f271b8' : 'transparent',
  borderWidth: 5,
  borderStyle: 'solid',
  borderRadius: 10,
  [theme.breakpoints.down('sm')]: {
    width: '100% !important', // Overrides inline-style
    height: 100,
  },
  '&:hover, &.Mui-focusVisible': {
    zIndex: 1,
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
    '& .MuiTypography-root': {
      // border: '4px solid currentColor',
    },
  },
}))

type ImageOptionRerenderProtectorProps = {
  option_key: OptionId
  onClickImageOption: (key: OptionId, value: boolean) => void
}

const ImageOptionRerenderProtector: React.FC<ImageOptionRerenderProtectorProps> = ({
  option_key,
  onClickImageOption,
}) => {
  const { quizAnswers, quizIndex } = React.useContext(QuizStoreContext)
  const selected =
    quizAnswers[quizIndex] && (quizAnswers[quizIndex][option_key] ?? false)

  return (
    <ImageOption
      selected={selected}
      option_key={option_key}
      onClickImageOption={onClickImageOption}
    />
  )
}

type ImageOptionProps = {
  selected: boolean
  option_key: OptionId
  onClickImageOption: (key: OptionId, value: boolean) => void
}

const ImageOption: React.FC<ImageOptionProps> = React.memo(
  ({ selected, option_key, onClickImageOption }) => {
    if (optionsDict[option_key] === undefined) {
      throw new Error(`optionsDict is undefined for option: ${option_key}`)
    }
    return (
      <ImageButton
        style={{
          borderRadius: 10,
          borderWidth: 0,
          height: '100%',
        }}
        selected={selected}
        focusRipple
        onClick={() => onClickImageOption(option_key, !selected)}>
        <ImageWithLoading
          src={optionsDict[option_key]!.content}
          style={{
            width: '100%',
            borderRadius: '8px',
            height: '100%',
          }}
        />
        {selected ? (
          <>
            <span
              style={{
                opacity: 1,
                backgroundSize: '62px 60px',
                backgroundRepeat: 'no-repeat',
                width: '62px',
                height: '60px',
                display: 'block',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundImage: `url(${window.location.origin}/checked-tick.svg)`,
              }}
            />
          </>
        ) : null}
        {/* <T variant='subtitle2' className='Quiz-image-title'>
          {optionsDict[option_key]?.name}
        </T> */}
      </ImageButton>
    )
  },
)

export default ImageOptionRerenderProtector
